import { useLocation, useNavigate } from "react-router-dom";

import emergencyHelpIcon from "../../../../assets/img/emergency/emergency-help-icon.png";

import ResultFormat from "..";
type Props = {};
export default function HelpResult(props: Props) {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <ResultFormat
      icon={emergencyHelpIcon}
      title="구조요청"
      description={`현재 상태가 관리자에게 전달 되었습니다. 관리자 확인 후 즉시 조치 예정이니 잠시만 기다려주세요.`}
      onCancel={() => navigate(state?.referer)}
      isManager={false}
    />
  );
}
